var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Chartist from 'chartist';
import { BaseChart } from '../base-chart';
var ChartistLine = /** @class */ (function (_super) {
    __extends(ChartistLine, _super);
    function ChartistLine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lineConfig = {
            showArea: true,
            lineSmooth: true,
            low: 0,
            fullWidth: true,
            chartPadding: {
                top: 0,
                left: 15,
                right: 30,
                bottom: 0,
            }
        };
        return _this;
    }
    ChartistLine.prototype.generate = function () {
        this.chart = new Chartist.Line(this.config.selector, this.transformChartData(), this.lineConfig);
    };
    ChartistLine.prototype.transformChartData = function () {
        return {
            labels: this.config.labels,
            series: this.config.data,
        };
    };
    ChartistLine.prototype.destroy = function () {
        if (this.chart) {
            this.chart.detach();
        }
    };
    return ChartistLine;
}(BaseChart));
export { ChartistLine };
